import { FC } from 'react'

import styled from 'styled-components'
import { useForm, Controller } from 'react-hook-form'

import { Button } from 'src/Components/Button'
import { Input } from 'src/Components/Input/index.tsx'
import { Select } from 'src/Components/Select'
import { Modal } from 'src/Components/Modal'
import { CreateUserBody, UserRole } from 'src/Redux/api/usersApi.ts'

import { assignableRoleOptions } from './constants.ts'

const ModalContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 20px 0;
  width: 100%;
`

const InputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

const emailPattern = {
  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  message: 'Некорректный формат email',
}

interface AddUserModalProps {
  onClose: () => void
  onAddUser: (user: CreateUserBody) => void
  isOpened: boolean
}

export const AddUserModal: FC<AddUserModalProps> = ({
  isOpened,
  onClose,
  onAddUser,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<CreateUserBody>({
    defaultValues: {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      phone: '',
      role: UserRole.SALES,
    },
  })

  const onSubmit = (data: CreateUserBody): void => {
    onAddUser(data)
    reset()
    onClose()
  }

  return (
    <Modal opened={isOpened} onClose={onClose} title='Добавить пользователя'>
      <ModalContainer>
        <InputContainer>
          <Controller
            name='email'
            control={control}
            rules={{ required: 'Email обязателен', pattern: emailPattern }}
            render={({ field }) => (
              <Input
                placeholder='example@company.com'
                label='Email'
                error={errors.email?.message}
                {...field}
              />
            )}
          />

          <Controller
            name='password'
            control={control}
            rules={{
              required: 'Пароль обязателен',
              minLength: {
                value: 6,
                message: 'Минимум 6 символов',
              },
            }}
            render={({ field }) => (
              <Input
                placeholder='Пароль'
                label='Пароль'
                type='password'
                error={errors.password?.message}
                {...field}
              />
            )}
          />

          <Controller
            name='firstName'
            control={control}
            render={({ field }) => (
              <Input
                placeholder='Имя'
                label='Имя'
                error={errors.firstName?.message}
                {...field}
              />
            )}
          />

          <Controller
            name='lastName'
            control={control}
            render={({ field }) => (
              <Input
                placeholder='Фамилия'
                label='Фамилия'
                error={errors.lastName?.message}
                {...field}
              />
            )}
          />

          <Controller
            name='phone'
            control={control}
            render={({ field }) => (
              <Input
                placeholder='Телефон'
                label='Телефон'
                error={errors.phone?.message}
                {...field}
              />
            )}
          />

          <Controller
            name='role'
            control={control}
            rules={{ required: 'Роль обязательна' }}
            render={({ field }) => (
              <Select
                placeholder='Выберите роль'
                label='Роль'
                error={errors.role?.message}
                data={assignableRoleOptions}
                {...field}
              />
            )}
          />
        </InputContainer>
      </ModalContainer>
      <ButtonContainer>
        <Button onClick={handleSubmit(onSubmit)}>Добавить</Button>
      </ButtonContainer>
    </Modal>
  )
}
